import React, { createContext, useContext, ReactNode, useState } from 'react';

export interface CurrentUser {
  id: string;
  auth_subject: string;
  email: string;
  display_name: string;
  role: 'user' | 'admin';
}

interface UserContextType {
  user: CurrentUser | null;
  setUser: (user: CurrentUser | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<CurrentUser | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useCurrentUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useCurrentUser must be used within UserProvider');
  }
  return context;
}
